import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopbarService {
  $subtitle =  new BehaviorSubject<string>('Intranet');
constructor() { }

  changeSubtitle(title) {
    this.$subtitle.next(title);
  }
}
